import React from 'react';
import { Helmet } from 'react-helmet';

const coreValues = [
  {
    icon: '/innovation.svg',
    title: "Innovation",
    desc: "We drive innovation through AI and emerging technologies to build efficient, scalable software solutions. Our focus is on reducing waste, enhancing productivity, and delivering future-ready digital products."
  },
  {
    icon: "/trust.svg",
    title: "Trust",
    desc: "We build trust through transparency, open communication, and consistent delivery. By fostering honest collaboration, we ensure strong relationships with clients, teams, and stakeholders."
  },
  {
    icon: "/entrepreneurship.svg",
    title: "Entrepreneurship",
    desc: "We empower our people to take ownership and embrace innovation. By fostering a culture of initiative and continuous learning, we support their growth and drive our company’s success."
  },
  {
    icon: "/excellence.svg",
    title: "Excellence",
    desc: "We strive for excellence by continuously enhancing our skills, adopting best practices, and encouraging collaboration to deliver outstanding software solutions."
  },
  {
    icon: "/integrity.svg",
    title: "Integrity",
    desc: "We uphold ethical practices and transparency, taking responsibility for our actions while maintaining the highest professional standards."
  },
  {
    icon: "/care.svg",
    title: "Care",
    desc: "We are dedicated to supporting our people, safeguarding the environment, and fostering sustainable growth to create a positive impact."
  },
  {
    icon: "/respect.svg",
    title: "Respect",
    desc: "We value human rights and ensure dignity, equity, and fairness in all our actions. Respect forms the foundation of trust and strong collaboration."
  }
];

const AboutUs = () => {
    return(
        <div className='about-container'>
         {/* <Helmet>
                <title>About Us | Pravisht Digital</title>
                <meta name="description" content="Learn about Pravisht's mission, core values, and how we drive innovation in digital solutions across industries worldwide." />
                <meta name="keywords" content="Pravisht, About Pravisht, Digital Solutions, Software Development, Innovation, Core Values, Custom Software, AI/ML, Cloud, DevOps, India, USA, UK, Germany, Canada, Australia" />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="Pravisht Digital" />
                <meta property="og:title" content="About Us | Pravisht Digital" />
                <meta property="og:description" content="Explore how Pravisht builds future-ready solutions, our core values, and global impact." />
                <meta property="og:image" content="/hero-bg2 (2).jpg" />
                <meta property="og:url" content="https://www.pravisht.com/about" />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet> */}


        <div className="breadcrumb">
          {/* <a href="/">Home</a> &gt; <a href="#">Who We Are</a> &gt; <span>About Us</span> */}
            <a href="/" className="mx-1">Home</a> &gt;  <span className="mx-1">About Us</span>
        </div>

        <div className="about-heading-section">
            <h1>Future-ready solutions, built today.</h1>
            <p>
            Pravisht's objective is to assist our customers in developing unique services and solutions while also assisting them in growing their businesses.
            </p>
        </div>

        {/* <div className="about-image">
            <img src="/banner.jpg" alt="Pravisht Digital" />
        </div> */}
        <div className="about-image-fullscreen">
        <img src="/hero-bg2 (2).jpg" alt="Pravisht Digital" />
        </div>
        <div className="aboutus-content">
            <div className="aboutus-image">
            <img src="/about_pravisht.jpg" alt="Plant View" />
            </div>
            <div className="aboutus-text-highlight">
    <p>
        At <strong style={{color:'#446FB3'}}>Pravisht</strong>, we bring together a powerful combination of technology expertise, deep domain knowledge, and a passion for quality. Our competencies span across&nbsp;
        <strong style={{color:'#446FB3'}}>Custom Software Development</strong>,&nbsp;
        <strong style={{color:'#446FB3'}}>Web &amp; Mobile Applications</strong>,&nbsp;
        <strong style={{color:'#446FB3'}}>UI/UX Design</strong>,&nbsp;
        <strong style={{color:'#446FB3'}}>Enterprise Solutions</strong>,&nbsp;
        <strong style={{color:'#446FB3'}}>Cloud &amp; DevOps</strong>,&nbsp;
        <strong style={{color:'#446FB3'}}>AI/ML Integrations</strong>, and&nbsp;
        <strong style={{color:'#446FB3'}}>Quality Assurance</strong>.
    </p>
    <p>
        We’ve successfully delivered solutions for a wide range of industries and collaborated with clients across&nbsp;
        <strong style={{color:'#446FB3'}}>India</strong>, <strong style={{color:'#446FB3'}}>USA</strong>, <strong style={{color:'#446FB3'}}> Canada</strong>, <strong style={{color:'#446FB3'}}>UK</strong>, <strong style={{color:'#446FB3'}}>Germany</strong>, and <strong style={{color:'#446FB3'}}>Australia</strong>.
    </p>
    </div>

        </div>

        <div className="aboutus-paragraphs">
    <p>
        Over the years, <strong style={{color:'#446FB3'}}>Pravisht</strong> has positioned itself as a leading provider of digital solutions and technology services, focused on delivering scalable, secure, and high-performance software across industries. Our foundation lies in our deep technical expertise, domain-driven approach, and relentless pursuit of quality.
    
        We provide services on extensive technology competencies, domain understanding, and a desire for quality in our software specialists to achieve this goal. We can efficiently handle software projects of any magnitude and complexity with our diversified IT professionals on board.
    
        We have experience working in a wide range of industries, building custom applications tailored to each client’s platform and needs. From startups to global enterprises, we have delivered value by understanding business objectives and ensuring on-time and on-budget delivery.
    </p>

    {/* <p>
        Our commitment to client success has enabled us to engage with several <strong style={{color:'#446FB3'}}>Fortune 500 companies</strong> in a relatively short period. Our service excellence, innovation mindset, and agility have played a key role in this achievement.
    </p>

    <p>
        <strong style={{color:'#446FB3'}}>Pravisht</strong> is headquartered in <strong style={{color:'#446FB3'}}>New Delhi, India</strong>, and operates globally with partners and subsidiaries in the <strong style={{color:'#446FB3'}}>United States</strong>, <strong style={{color:'#446FB3'}}>Canada</strong>, <strong style={{color:'#446FB3'}}>United Kingdom</strong>, <strong style={{color:'#446FB3'}}>Australia</strong>, and <strong style={{color:'#446FB3'}}>Germany</strong>. Our growing international presence enables us to support clients around the world with local understanding and global standards.
    </p>

    <p>
        As we move forward, our mission remains clear — to empower businesses through innovation and technology, while remaining rooted in trust, responsibility, and a vision for sustainable digital growth.
    </p> */}
        </div>

        <div className='Our-Core-Purpose'>
            <h2>Our Core Purpose</h2>
            <p>
                At <strong style={{color:'#446FB3'}}>Pravisht</strong>, our core purpose is to empower businesses with innovative digital solutions that drive real-world impact. We blend technology with strategy to deliver user-centric, scalable services focused on trust, long-term growth, and measurable outcomes.
            </p>
        </div>

        {/* 👇 Our Core Values Section */}
      
      {/* <div className='our-core-purpose'>
        <h2>Our Core Purpose</h2>
        <p>
          At <strong style={{color:'#446FB3'}}>Pravisht</strong>, our core purpose is to empower businesses with innovative digital solutions that drive real-world impact. We blend technology with strategy to deliver user-centric, scalable services focused on trust, long-term growth, and measurable outcomes.
        </p>
      </div> */}

      <div className="our-core-values-section">
       

        <div className="core-values-container">
            <div  className="core-value-card">
                 <h2>Our Core Values</h2>
        <p className="core-values-description">
          Our core values underpin everything we do at Pravisht. These universal values guide our behaviour as we expand into new markets and countries.
        </p>
            </div>
          {coreValues.map((val, index) => (
            <div key={index} className="core-value-card">
              <div className="core-value-icon"><img src={val.icon} alt={val.title} className="icon-img" />  <h3 className="core-value-title">{val.title}</h3></div>
             
              <p className="core-value-desc">{val.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
    );
};

export default AboutUs;